import s from './IdeenKennzahlen.module.scss'

/**
 * Die vier Zahlen über der Tafel: in Zone, offen, vorgeschlagen, im Markt.
 * Eine Zeile, keine Karten — die Tafel ist die Sache, die Zahlen sind ihr
 * Rahmen.
 */
export function IdeenKennzahlen({ inZone, offen, vorgeschlagen, imMarkt, hinweis }: {
  inZone: number
  offen: number
  /** Noch nicht angenommen — die Entscheidung steht aus. */
  vorgeschlagen: number
  imMarkt: number
  /** Rechts, gedämpft: etwa „eine Idee ist eine Regel mit Kurs, keine Order". */
  hinweis?: string
}) {
  return (
    <div className={s.zeile}>
      <span><b className={s.good}>{inZone}</b> in Zone</span>
      <span><b>{offen}</b> offen</span>
      <span><b className={s.accent}>{vorgeschlagen}</b> vorgeschlagen</span>
      <span><b>{imMarkt}</b> im Markt</span>
      {hinweis && <span className={s.hinweis}>{hinweis}</span>}
    </div>
  )
}
